<template>
    <div :class="css.container" v-loading="loading" v-if="exist">
        <!-- * 头部 -->
        <div :class="css.header">
            <!-- * 名称 -->
            <div :class="css.name" class="font-variable font-bold color-1">{{ name }}</div>
            <!-- * 排序模式控制器 -->

            <DefaultSelector :class="css.modes" v-model="mode" :candidates="option" @change="methods.mode" />
        </div>

        <div :class="css.body" ref="container">
            <!-- * 内容 -->
            <UiTooltipFunction :class="css.content" ref="tooltip">
                <div :class="css.canvas" ref="body"></div>
                <template #content>
                    <renderView />
                </template>
            </UiTooltipFunction>

            <!-- * 标签 -->
            <div :class="css.tags">
                <div :class="css.tag" v-for="(value, key) in tags" :key="key">
                    <div :class="css.rect" :style="{ backgroundColor: value.color }"></div>
                    <div :class="css.name">{{ value.name }}</div>
                </div>
            </div>
        </div>
    </div>
</template>

<script lang="tsx" setup>
//* 组件库
import { UiTooltipFunction } from "various-ui";
//* 内部组件
import { DefaultSelector } from "@/components/controls";
//* 组件属性
import { ModulePropsOption } from "./index";
import { useComposable } from "./src/composable";
//* 样式
import css from "./style/index.module.less";

//* 插件
const i18n = useI18n();
//* 组件属性注册
const define = defineProps(ModulePropsOption);

//* 组合函数
const { refs, nodes, events, methods, variable, computeds } = useComposable(define);
const { mode, tags, loading, exist } = refs;
const { body, tooltip, container } = nodes;
const { render, hidden } = methods;
const { option } = computeds;

//* 组件卸载时, 注销观察者
onBeforeUnmount(() => {
    variable.observer.value?.disconnect();
});

//* 组件属性导出
defineExpose({ render, hidden });

//* 渲染函数（悬浮信息）
const renderView = defineComponent({
    render() {
        if (define.type == "tissue") {
            return (
                <div class={css.window} onMousemove={events.view.mousemove} onMouseleave={events.view.mouseleave}>
                    <div class="title-5">{refs.info.value?.name || "--"}</div>
                    <div class={css.context}>
                        <span>{i18n.t("MeanRPKM")}:</span>
                        <span class={`${css.active} font-bold`}>{`${refs.info.value?.value}±${refs.info.value?.scope}`}</span>
                    </div>
                    <div class={css.context}>
                        <span>{i18n.t('NumberOfSamples')}:</span>
                        <span class={`${css.active} font-bold`}>{refs.info.value?.number}</span>
                    </div>
                </div>
            );
        } else {
            return (
                <div class={css.window} onMousemove={events.view.mousemove} onMouseleave={events.view.mouseleave}>
                    <div class="title-5">{refs.info.value?.name || "--"}</div>
                    <div class={css.context}>
                        <span>Mean nTPM:</span>
                        <span class={`${css.active} font-bold`}>{`${refs.info.value?.value}`}</span>
                    </div>
                </div>
            );
        }
    },
});
</script>
